import errorStyles from '../../styles/error/error.module.css';

export const OutOfOrderBlock = () => {
	return (
		<section className={`${errorStyles.errorWrapper} m-5 p-5`}>
			<p className="text-red-CPH text-lg">Out of order</p>
		</section>
	);
};
